import { useEffect } from 'react';
import { useInView } from 'common/hooks';
import { useSelector } from 'react-redux';
import { selectPopularCategories } from 'containers/catalogue/popular-categories/selectors';
import { selectTopCategories } from 'containers/catalogue/catalogue/selectors';
import { selectSelectedFilterItems } from 'containers/catalogue/catalogue/components/catalogue-content/selectors';
import { TCategory } from 'data';
import { getPath } from 'selectors';
import {
	GAClickProduct,
	GAImpressions,
	GAPromoClick,
	getCatalogueCardPosition,
	getPopularCardPosition,
	TGAClickProduct,
	TGAImpressions,
	TGAPromoClick,
} from 'utils/analytics';

export const useCardClickAnalytics = ({
	categoryData,
	isPopularCard,
	isPopularOrderCard,
	isCatalogueOrderCard,
}) => {
	const path = useSelector(getPath);
	const topCategories = useSelector(selectTopCategories);
	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const popularCategories = useSelector(selectPopularCategories);

	const { categoryId, categoryName, price } = categoryData as TCategory;

	let cardPosition: string;

	if (isCatalogueOrderCard) {
		cardPosition = getCatalogueCardPosition(topCategories, selectedFilterItems, categoryId);
	} else if (isPopularOrderCard || isPopularCard) {
		cardPosition = getPopularCardPosition(popularCategories, categoryId);
	} else {
		cardPosition = '1'; // чтобы не было ошибок при клике по общей карточке
	}

	const productData = {
		productId: categoryId.toString(),
		productName: categoryName,
		productPrice: price?.toString() || '0',
		productPosition: cardPosition,
	};

	const eventData: TGAImpressions = {
		elementBlock: 'serviceList',
		...productData,
	};

	const blockPlacement = path.includes('ustanovka-i-remont')
		? 'servicePage_top'
		: 'servicePage_bottom';

	const analyticsClickHandler = (event: React.MouseEvent<HTMLElement>) => {
		if (isCatalogueOrderCard) {
			const element = event.target as HTMLElement;
			const elementName =
				element.closest('[data-analyticsname]')?.getAttribute('data-analyticsname') ||
				'productBlockLink';
			const data: TGAClickProduct = {
				elementName,
				...eventData,
			};
			GAClickProduct(data);
		} else if (isPopularOrderCard || isPopularCard) {
			const data: TGAPromoClick = {
				elementBlock: 'servicePage / popular',
				promotions: [
					{
						name: blockPlacement,
						creative: productData.productName,
						position: cardPosition,
					},
				],
			};
			GAPromoClick(data);
		}
	};

	// scroll analytics
	const { ref, inView } = useInView();

	useEffect(() => {
		if (inView) {
			if (isCatalogueOrderCard) {
				GAImpressions(eventData);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inView]);

	return {
		ref,
		analyticsClickHandler,
	};
};
